export default "__VITE_ASSET__2e2c33e2__"